import { RouterStore } from "mobx-react-router";
import { Microsite, Site } from "../decoders/Sites.types";

export function reverseRoute(
    site: Site | Microsite | undefined,
    pageName: string,
    params: { [key: string]: string | null | undefined } = {},
) {
    // Look up page
    const page = site?.config?.routes.find(route => route.name === pageName);
    if (!page) {
        return;
    }

    // Replace params in url
    let url: string = page.path;
    Object.keys(params).forEach(key => {
        const param = params[key];
        if (param) {
            url = url.replace(`<${key}>`, param);
        }
    });

    // Ensure url has a trailing slash, then return it
    if (!url.endsWith("/")) {
        url += "/";
    }
    if (site instanceof Microsite) {
        url = `/featured/${site.index?.slug}${url}`;
    }
    return url;
}

export const hasPage = (site: Site | Microsite | undefined, pageName: string) =>
    !!site?.config?.routes.some(route => route.name === pageName);

export const isPreviewRequest = (router: RouterStore) => /^\/_preview$/.test(router.location?.pathname);
